export const PROMO_CARD_WIDTH = '564px';
export const PROMO_CARD_MOBILE_WIDTH = '270px';

export const PROMO_CARD_HEIGHT = '290px';
export const PROMO_CARD_MOBILE_HEIGHT = '300px';

export const ALLOWED_MEASURE_UNITS = ['px', '%'] as const;

export const BG_SIZE_OPTIONS = [
    {
        description:
            'Изображение масштабируется для максимального покрытия блока. Если размер контейнера отличается от изображения - излишки обрезаются',
        value: 'cover',
    },
    { description: 'Изображение изменяет размер, сохраняя пропорции', value: 'auto' },
    {
        description:
            'Изображение масштабируется как можно больше c сохранением пропорций и не обрезается',
        value: 'contain',
    },
    {
        description: 'Изображение сохраняет исходный размер',
        value: 'initial',
    },
] as const;

export const BORDER_RADIUS_OPTIONS = [
    { value: 0 },
    { value: 4 },
    { value: 8 },
    { value: 12 },
    { value: 16 },
    { value: 24 },
    { value: 32 },
] as const;
